import styled from "styled-components";
import { Button, Layout, Table } from "antd";

const { Content } = Layout;


export const StyledContent = styled(Content)`
  height: 100%;
  background: whitesmoke;
  overflow-y: hidden;
  background-image: url("/Mask group.png");
  background-size: cover;
  z-index: 1;
`;

export const SubscriptionWrapper = styled.div`
  max-width: 1500px;
  min-height: 810px;
  margin: auto;
  padding: 20px;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`;

export const SubscriptionTable = styled(Table)`
  margin-top: 10px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;

export const PlansContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
`;

export const PlanCard = styled.div`
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  text-align: start;
  min-height: 380px;
  width: 340px;
  border:  "2px solid #005461";
`;


export const PlanTitle = styled.h3`
  font-size: 20px;
  color: #005461;
  margin-bottom: 10px;
`;

export const PlanPrice = styled.p`
  font-size: 24px;
  font-weight: bold;
  margin: 5px 0;
`;

export const PlanFeatures = styled.div`
  margin-top: 10px;
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    margin: 5px 0;
    font-size: 14px;
  }
`;

export const SubscribeButton = styled(Button)`
  
  color: white;
  //padding: 10px;
  width: 100%;
  height: 13%;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 16px;


  &:hover {
    opacity: 0.8;
  }
`;